import React, {Component} from "react"
import PropTypes from "prop-types"

import History from "@irati/utils/history"
import {RewardOrder} from "@irati/types"
import {injectIntl, InjectIntl} from "@irati/utils/lang"

import Receipt from "../Receipt"

interface Props extends InjectIntl {
  onAfterExitModal(): void,
  rewardOrder: RewardOrder,
  redirectToFeed?: boolean
}

class RewardSuccessPopup extends Component<Props> {
  static defaultProps = {
    redirectToFeed: false,
    onAfterExitModal: null
  }

  static contextTypes = {
    appPath: PropTypes.string.isRequired
  }

  handleAfterExit = () => {
    const {redirectToFeed, onAfterExitModal} = this.props

    if (redirectToFeed) {
      History.push("/reward", this.context, false)
    }
    if (typeof onAfterExitModal === "function") {
      onAfterExitModal()
    }
  }

  render() {
    const {formatMessage, rewardOrder} = this.props
    return (
      <Receipt buttonText={formatMessage({id: "reward.success.receipt.button"})} onClose={this.handleAfterExit} rewardOrder={rewardOrder} />
    )
  }
}

export default injectIntl(RewardSuccessPopup)
